import { render, staticRenderFns } from "./departMemberLevel.vue?vue&type=template&id=efda0200&"
import script from "./departMemberLevel.vue?vue&type=script&lang=js&"
export * from "./departMemberLevel.vue?vue&type=script&lang=js&"
import style0 from "./departMemberLevel.vue?vue&type=style&index=0&id=efda0200&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports